import React, {Component} from 'react';
import {Form, InputNumber, message, Modal} from "antd";
import {WasteStreamFilter} from "../../../../filters/WasteStreamCode";
import {WasteStreamUpdate} from "../../../../models/waste_stream";

const FormItem = Form.Item;

class EditWasteModalForm extends Component {
    onSubmit = () => {
        const {id} = this.props.item;
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (!err) {
                WasteStreamUpdate(id, values)
                    .then(() => {
                        message.success('Waste Stream updated successfully');
                        form.resetFields();
                        this.props.reload();
                        this.props.onClose()
                    });
            }
        });
    };

    componentDidUpdate(prevProps) {
        if (this.props.item && prevProps.item !== this.props.item)
            this.props.form.setFieldsValue({quantity: this.props.item.quantity})
    }


    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <Modal destroyOnClose={true} onCancel={this.props.onClose} title="Edit Waste Stream" centered
                   visible={this.props.visible} width={'50%'} okText="Save" onOk={this.onSubmit}
                   className="view-data-modal">
                <div className="row">
                    <div className="col-sm-9 col-12">
                        <FormItem label="Waste Stream">
                            {getFieldDecorator('waste_stream', {
                                rules: [{required: true, message: 'Please enter waste stream'}],
                            })(
                                <WasteStreamFilter/>
                            )}
                        </FormItem>
                    </div>
                    <div className="col-sm-3 col-12">
                        <FormItem label="Quantity">
                            {getFieldDecorator('quantity', {
                                rules: [{required: true, message: 'Please enter quantity'}],
                            })(
                                <InputNumber placeholder="Enter Here"/>
                            )}
                        </FormItem>
                    </div>
                </div>
            </Modal>
        );
    }
}

export const EditWasteModal = Form.create()(EditWasteModalForm);


// WEBPACK FOOTER //
// ./src/pages/dispatch/routes/popup/EditWasteModal.jsx